
import formatDecimalClean from "@/app/infrastructures/misc/common-library/FormatDecimalClean";
import Icons from "@/app/ui/components/icons/index.vue";
import { PosLeaderboardCard } from "@/domain/entities/PosLeaderboard";
import { FcsPermissionDashboard } from "@/feature-flags/flags-dashboard";
import { computed, defineComponent, ref } from "vue";
import PopupTopCustomer from "./popup-top-customer.vue";
import { useI18n } from 'vue-i18n';

type SliderType =
  | "national"
  | "area"
  | "newPos"
  | "topCustomer"
  | "operational";
interface SliderItem {
  type: SliderType;
  text: string;
}

export default defineComponent({
  name: "slider-leaderboard",

  components: {
    Icons,
    PopupTopCustomer
  },

  props: {
    cardData: {
      type: PosLeaderboardCard,
      default: new PosLeaderboardCard(),
      required: true
    }
  },

  setup(props) {
    const { t } = useI18n();
    const activeIndex = ref<number>(0);
    const showTopCustomer = ref<boolean>(false);

    const getOperationalHours = computed(() =>
      FcsPermissionDashboard.config_leaderboard_po_operational_hours.getValue()
    );

    const formatRupiah = (val: number) => {
      if (val < 1_000) {
        return `${val.toLocaleString("id-ID")}`;
      }

      if (val < 1_000_000) {
        const rb = val / 1_000;
        return `${formatDecimalClean(rb.toFixed(1))}rb`;
      }

      const jt = val / 1_000_000;
      return `${formatDecimalClean(jt.toFixed(1))}jt`;
    };

    const dataSlider = computed(() => {
      const { national, area, newPos } = props.cardData;

      const result: SliderItem[] = [];

      // slide poin 1 nasional
      if (national?.nextRevenue > 0) {
        result.push({
          type: "national",
          text: `${t("dashboard.leaderboard.sliderLeaderboard.national1")} <b>${formatRupiah(
            national.nextRevenue
          )}.</b> ${t("dashboard.leaderboard.sliderLeaderboard.national2")} <b>${formatRupiah(
            national.nextReward
          )}</b>.`
        });
      }

      // slide poin 2 area / new pos
      const areaSource = area?.nextRevenue > 0 ? area : newPos;

      if (areaSource?.nextRevenue > 0) {
        result.push({
          type: areaSource.scope === "AREA" ? "area" : "newPos",
          text: `${t("dashboard.leaderboard.sliderLeaderboard.slides.areaOrNewPos1")} <b>${formatRupiah(
            areaSource.nextRevenue
          )}</b> ${t("dashboard.leaderboard.sliderLeaderboard.slides.areaOrNewPos2")} ${t(
            areaSource.scope === "AREA"
              ? 'dashboard.leaderboard.sliderLeaderboard.scope.area'
              : 'dashboard.leaderboard.sliderLeaderboard.scope.newPos')} <b>${formatRupiah(areaSource.nextReward)}</b>.`
        });
      }

      // slide poin 3 top customer
      result.push({
        type: "topCustomer",
        text: `${t("dashboard.leaderboard.sliderLeaderboard.slides.topCustomerPrefix")} <b class="text-red-lp-600 hover:underline cursor-pointer">${t("dashboard.leaderboard.sliderLeaderboard.slides.topCustomerHighlight")}</b> ${t("dashboard.leaderboard.sliderLeaderboard.slides.topCustomerSuffix")}`
      });

      // slide poin 4 jam operasional
      result.push({
        type: "operational",
        text: `${t("dashboard.leaderboard.sliderLeaderboard.slides.operational1")} <b class="text-red-lp-600">(${getOperationalHours.value})</b> ${t("dashboard.leaderboard.sliderLeaderboard.slides.operational2")}`
      });

      return result;
    });

    const pages = computed(() => {
      const result = [];
      for (let i = 0; i < dataSlider.value.length; i += 2) {
        result.push(dataSlider.value.slice(i, i + 2));
      }
      return result;
    });

    const nextSlide = () => {
      activeIndex.value =
        activeIndex.value === pages.value.length - 1
          ? 0
          : activeIndex.value + 1;
    };

    const onOpenModalTopCustomer = () => {
      showTopCustomer.value = true;
    };

    return {
      pages,
      activeIndex,
      dataSlider,
      nextSlide,
      onOpenModalTopCustomer,
      getOperationalHours,
      showTopCustomer
    };
  }
});
